import { render, staticRenderFns } from "./uOttawa1321Lab4Question2.vue?vue&type=template&id=688e468a&"
import script from "./uOttawa1321Lab4Question2.vue?vue&type=script&lang=ts&"
export * from "./uOttawa1321Lab4Question2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VBtnToggle,VForm})
